import React, { useState, useEffect } from 'react'
import { string, node } from 'prop-types'
import { usePrivacyOptOutCheck, useFetch } from '../../utils/hooks'
import { APIENDPOINT, getCWPEnvironmentForURL, getNavItems } from '../../utils/common-utils'

export const FooterPersonalized = props => {
  const [contentIdentifier, setContentIdentifier] = useState()

  const env = getCWPEnvironmentForURL(window.location)

  const footerApiUrl =
    contentIdentifier && `${APIENDPOINT(env).base}halapi/documents/${contentIdentifier}`

  const { status, data, error } = useFetch(footerApiUrl)

  useEffect(() => {
    setContentIdentifier(props.contentIdentifier)
  }, [props])

  const showOptOut = usePrivacyOptOutCheck()

  const navItems = getNavItems(data.navLink, showOptOut)

  return (
    <div className='App'>
      <main>
        {status === 'error' && <div>{error}</div>}
        {status === 'fetching' && <div className='loading'></div>}
        {status === 'fetched' && (
          <ul>
            {navItems.map((item, index) => (
              <li className='ms-listItem' key={`menu-item-${index.toString()}`}>
                <a
                  className='u-textColorDefault u-padding4'
                  href={`${item.Link[0].string}`}
                  target={`${item.target}`}
                  rel='noopener noreferrer'>
                  {item.text}
                </a>
              </li>
            ))}
          </ul>
        )}
      </main>
    </div>
  )
}

FooterPersonalized.propTypes = {
  contentIdentifier: string,
}

FooterPersonalized.defaultProps = {
  contentIdentifier: '',
}
